export default __webpack_public_path__ + "static/media/Infected.c0281e03.svg";